import createLucideIcon from '../createLucideIcon';

const ArrowLeftFromLine = createLucideIcon('ArrowLeftFromLine', [
  ['line', { x1: '3', x2: '17', y1: '12', y2: '12', key: '10k5p2' }],
  ['polyline', { points: '9 6 3 12 9 18', key: 'biqh3b' }],
  ['path', { d: 'M21 19V5', key: 'b4bplr' }],
]);

export default ArrowLeftFromLine;
